import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import ruLang from './locales/ru.json'
import ukLang from './locales/uk.json'
import { LOCALS } from 'lib/i18next/types'

const resources = {
  [LOCALS.RU]: {
    translation: ruLang,
  },
  [LOCALS.UK]: {
    translation: ukLang,
  },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: LOCALS.UK,
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
